export const SORT_ICONS = {
  sortUnSort: '<i class="ci ci-table-sorting-default" />',
  sortAscending: '<i class="ci ci-table-sorting-asc" />',
  sortDescending: '<i class="ci ci-table-sorting-desc" />'
}



// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/Icons.js